import { render, staticRenderFns } from "./noaccess.vue?vue&type=template&id=e5435b1e&"
import script from "./noaccess.vue?vue&type=script&lang=js&"
export * from "./noaccess.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VAlert,VContainer})
